import {
  BatchTranslationResponse,
  DetectTranslationResponse,
  TranslationResponse,
} from "@/types";
import { sendPostRequest } from "@/utils/apiClient";

/**
 * Translates a single text.
 * @param apiKey - User's API key
 * @param text - Text to translate
 * @param target - Target language
 * @param source - Source language (default: auto)
 * @param retryCount - Number of retry attempts (default: 3)
 * @returns Translation response or null
 */
export const Translate = async (
  apiKey: string,
  text: string,
  target: string,
  source: string = "auto",
  retryCount: number = 3
): Promise<TranslationResponse | null> => {
  const url = "/translate";
  const params = {
    api_key: apiKey,
    text,
    source,
    target,
    retry_count: retryCount.toString(),
  };

  return await sendPostRequest<TranslationResponse>(url, {}, params);
};


/**
 * Translates multiple texts in a batch.
 * @param apiKey - User's API key
 * @param texts - Array of texts to translate
 * @param target - Target language
 * @param source - Source language (default: auto)
 * @param retryCount - Number of retry attempts (default: 3)
 * @returns Batch translation response or null
 */
export const BatchTranslator = async (
  apiKey: string,
  texts: string[],
  target: string,
  source: string = "auto",
  retryCount: number = 3
): Promise<BatchTranslationResponse | null> => {
  const url = "/batch_translate";
  const body = { texts, source, target, retry_count: retryCount.toString() };
  const params = { api_key: apiKey };

  return await sendPostRequest<BatchTranslationResponse>(url, body, params);
};



/**
 * Translates multiple texts in a batch.
 * @param apiKey - User's API key
 * @param text - text to translate
 * @returns Detect translation response or null
 */
export const DetectLang = async (
  apiKey: string,
  text: string,
): Promise<DetectTranslationResponse | null> => {
  const url = "/detect";
  const params = {text: text, api_key: apiKey };

  return await sendPostRequest<DetectTranslationResponse>(url, {}, params);
};
